<template>
  <div class="quill-editor">
    <slot name="toolbar" />
    <div id="editor" ref="editor" />
  </div>
</template>
<script>
// require sources
import _Quill from 'quill';
import defaultOptions from './options';
import QuillBetterTable from 'quill-better-table';
// import Parchment from 'parchment';
const Quill = window.Quill || _Quill;
// 注册表格模块
Quill.register(
  {
    'modules/better-table': QuillBetterTable,
  },
  true,
);

const AlignStyle = Quill.import('attributors/style/align');
Quill.register(AlignStyle, true);
const SizeStyle = Quill.import('attributors/style/size');
Quill.register(SizeStyle, true);
// pollfill
if (typeof Object.assign !== 'function') {
  Object.defineProperty(Object, 'assign', {
    value(target) {
      if (target == null) {
        throw new TypeError('Cannot convert undefined or null to object');
      }
      const to = Object(target);
      for (let index = 1; index < arguments.length; index++) {
        const nextSource = arguments[index];
        if (nextSource != null) {
          for (const nextKey in nextSource) {
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true,
  });
}

// export
export default {
  name: 'QuillEditor',
  props: {
    content: String,
    auth: String,
    title: String,
    value: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    globalOptions: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    // 需要新增的模板字符串
    templateStr: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      sizeList: Array.from(Array(58), (item, index) => String(index + 12)),
      currentOptions: {},
      currentContent: '',
      defaultOptions,
    };
  },
  watch: {
    // Watch content change
    content: {
      handler(newVal) {
        if (this.quill) {
          if (newVal && newVal !== this.currentContent) {
            this.currentContent = newVal;
            // this.quill.dangerouslyPasteHTML(newVal)   // // 源码方法，2.0.0版本报错
            this.$el.querySelector('.ql-editor').innerHTML = newVal;
            // this.$refs.editor.children[0].innerHTML = newVal;
          } else if (!newVal) {
            this.quill.setText('');
          }
        }
      },
      deep: true,
    },
    // Watch content change
    value(newVal) {
      const val = newVal;
      if (this.quill) {
        if (val && val !== this.currentContent) {
          this.currentContent = val;
          // this.quill.dangerouslyPasteHTML(val)
          this.$el.querySelector('.ql-editor').innerHTML = val;
          // this.$refs.editor.children[0].innerHTML = val;
        } else if (!val) {
          this.quill.setText('');
        }
      }
    },
    // Watch disabled change
    disabled(newVal) {
      if (this.quill) {
        this.quill.enable(!newVal);
      }
    },
    // 改变这个值来让编辑器新增字符串在当前光标位置 只需要监听改变
    templateStr(newVal) {
      if (this.quill) {
        // 手动插入dom到编辑器里
        this.quill.clipboard.dangerouslyPasteHTML(
          this.quill.selection.savedRange.index,
          `<p>${newVal}</p>`,
        );
        // 这个方法可以获取光标位置
        this.quill.setSelection(this.quill.selection.savedRange.index);
      }
    },
  },
  created() {
    // 打开页面时注册音频节点,防止音频节点清除
    this.registerAudio();
    this.stockBlot();
  },
  mounted() {
    // this.init();
    // this.size();
    this.initialize();
    // 只允许粘贴纯文本
    this.quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
      const ops = [];
      delta.ops.forEach((op) => {
        if (op.insert && typeof op.insert === 'string') {
          ops.push({
            insert: op.insert,
            attributes: op.attributes,
          });
        }
      });
      delta.ops = ops;
      return delta;
    });
  },
  beforeDestroy() {
    this.quill = null;
    delete this.quill;
  },
  methods: {
    // 自定义blot
    stockBlot() {
      // 引入源码中的BlockEmbed
      const BlockEmbed = Quill.import('blots/block/embed');
      // 定义新的blot类型
      class StockEmbed extends BlockEmbed {
        static create(value) {
          const node = super.create(value);
          node.setAttribute('contenteditable', 'false');
          node.setAttribute('width', '100%');
          //   设置自定义html
          node.innerHTML = this.transformValue(value);
          return node;
        }

        static transformValue(value) {
          let handleArr = value.split('\n');
          handleArr = handleArr.map((e) => e.replace(/^[\s]+/, '').replace(/[\s]+$/, ''));
          return handleArr.join('');
        }

        // 返回节点自身的value值 用于撤销操作
        static value(node) {
          return node.innerHTML;
        }
      }
      StockEmbed.blotName = 'StockEmbed';
      StockEmbed.className = 'embed-innerApp';
      StockEmbed.tagName = 'div';
      Quill.register(StockEmbed, true);
    },
    registerAudio() {
      // 注册音频节点
      const BlockEmbed = Quill.import('blots/block/embed');
      class AudioBlot extends BlockEmbed {
        static create() {
          const node = super.create();
          return node;
        }
      }
      AudioBlot.blotName = 'audio';
      AudioBlot.tagName = 'audio'; // 自定义的标签为audio
      Quill.register(AudioBlot);
    },
    cancelTabindex() {
      const arr = document.querySelectorAll('.ql-picker-label');
      for (let i = 0; i < arr.length; i++) {
        arr[i].tabindex = 'unset';
      }
    },
    size() {
      const Parchment = Quill.import('parchment');
      // class Font extends Parchment.Attributor.Class{}
      const FontStyle = new Parchment.Attributor.Class('size', 'ql-size', {
        scope: Parchment.Scope.INLINE,
        whitelist: this.sizeList,
      });
      Quill.register(
        {
          'formats/size': FontStyle,
        },
        true,
      );
    },

    // Init Quill instance
    initialize() {
      if (this.$el) {
        // Instance
        this.quill = new Quill('#editor', {
          theme: 'snow',
          // boundary: document.body,
          modules: {
            table: false,
            toolbar: {
              container: [
                [
                  'undo',
                  'redo',
                  'clean',
                  // { size: ["small", false, "large", "huge"] },
                  { header: [1, 2, 3, 4, 5, 6, false] },
                  'bold',
                  'italic',
                  'underline',
                  'strike',
                  { color: [] },
                  { background: [] },
                  { align: [] },
                  { indent: '+1' },
                  { indent: '-1' },
                  { list: 'ordered' },
                  'better-table',
                  'blockquote',
                  'link',
                ],
              ],
              handlers: {
                'better-table'() {
                  this.quill.getModule('better-table').insertTable(3, 3);
                },
                undo() {
                  this.quill.history.undo();
                },
                redo() {
                  this.quill.history.redo();
                },
                // 'color':function (e) {
                // }
              },
            },
            history: {
              delay: 2000,
              maxStack: 500,
              userOnly: true,
            },
            'better-table': {
              operationMenu: {
                color: {
                  colors: ['green', 'red', 'yellow', 'blue', 'white'],
                  text: '背景色:',
                },
                items: {
                  insertColumnRight: {
                    text: '插入右列',
                  },
                  insertColumnLeft: {
                    text: '插入左列',
                  },
                  insertRowUp: {
                    text: '插入上行',
                  },
                  insertRowDown: {
                    text: '插入下行',
                  },
                  mergeCells: {
                    text: '合并表格',
                  },
                  unmergeCells: {
                    text: '取消合并',
                  },
                  deleteColumn: {
                    text: '删除列',
                  },
                  deleteRow: {
                    text: '删除行',
                  },
                  deleteTable: {
                    text: '删除表格',
                  },
                },
              },
            },
            keyboard: {
              bindings: QuillBetterTable.keyboardBindings,
            },
          },
          placeholder: '从这里开始输入正文',
          readOnly: false,
          clipboard: {
            matchVisual: false,
            //   matchers: [
            //     ['B', customMatcherA],
            //     [Node.TEXT_NODE, customMatcherB]
            //   ]
          },
        });
        this.quill.enable(false);

        // Set editor content
        if (this.value || this.content) {
          this.$el.querySelector('.ql-editor').innerHTML = this.value || this.content;
          // this.quill.pasteHTML(this.value || this.content)
          // this.quill.dangerouslyPasteHTML(this.value || this.content)
        }

        // Disabled editor
        if (!this.disabled) {
          this.quill.enable(true);
        }
        // 撤销
        this.$el.querySelector(
          '.ql-undo',
        ).innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>撤回</title><g id="pc_icon/编辑器/撤回" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="编组-21"><rect id="矩形" fill="#FFFFFF" opacity="0" x="0" y="0" width="24" height="24"></rect><path d="M12,11.9203588 L11.3573335,13 L6,9 L11.3573335,5 L12,6.07964123 L9.428,8 L18,8 L18,8.75 L17.999,16 L18,16 L18,17.5 L10,17.5 L10,16 L16.499,16 L16.5,9.5 L8.759,9.5 L12,11.9203588 Z" id="形状结合" fill-opacity=".65" fill="#000000"></path></g></g></svg>`;
        // 重做
        this.$el.querySelector(
          '.ql-redo',
        ).innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>重做</title><g id="pc_icon/编辑器/重做" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="编组-22"><rect id="矩形备份-43" fill="#FFFFFF" opacity="0" x="0" y="0" width="24" height="24"></rect><g id="编组-7备份" transform="translate(12, 11.5) scale(-1, 1) translate(-12, -11.5) translate(6, 5)" fill="#000000" fill-opacity=".65"><path d="M6,6.92035877 L5.35733354,8 L0,4 L5.35733354,0 L6,1.07964123 L3.428,3 L12,3 L12,3.75 L11.999,11 L12,11 L12,12.5 L4,12.5 L4,11 L10.499,11 L10.5,4.5 L2.759,4.5 L6,6.92035877 Z" id="形状结合"></path></g></g></g></svg><div class="tools-border"></div>`;
        // 清除
        this.$el.querySelector(
          '.ql-clean',
        ).innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>清除</title><g id="橡皮擦" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="编组-23"></g><g id="编组-7" transform="translate(12.5, 11) rotate(135) translate(-12.5, -11) translate(9, 5)" fill="#000000" fill-rule="nonzero"><path d="M7,0 L7,12 L0,12 L0,0 L7,0 Z M6.125,0.923076923 L0.875,0.923076923 L0.875,11.0769231 L6.125,11.0769231 L6.125,0.923076923 Z" id="矩形" fill-opacity="0.65"></path><path d="M7,11.6 L0,11.6 M0.875,6 L0.875,11.08 L6.125,11.08 L6.125,6" id="矩形备份-5" fill-opacity="0.647590691"></path></g></g></svg><div class="tools-border"></div>`;
        // 加粗
        this.$el.querySelector(
          '.ql-bold',
        ).innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>加粗</title><g id="加粗" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0.645842439"><g id="编组-25" fill="#000000" fill-rule="nonzero"><g id="编组" transform="translate(8, 5)"><path d="M8.30432825,6.8558297 C7.950715,6.34010643 7.42898215,5.99709724 6.73964072,5.82728592 L6.73964072,5.794388 C7.10500701,5.6298984 7.41211909,5.44605709 7.66097697,5.24286405 C7.91034585,5.05079826 8.10146053,4.84760522 8.234832,4.63376875 C8.49544292,4.18384132 8.62012736,3.7121432 8.60837432,3.21819061 C8.60837432,2.25253991 8.29257521,1.47605225 7.66097697,0.888727625 C7.03499976,0.307208515 6.09884445,0.0111272375 4.85302205,0 L6.96331881e-13,0 L6.96331881e-13,12 L5.27919755,12 C6.27616208,12 7.10756202,11.684567 7.77441937,11.0532172 C8.44689775,10.4494436 8.78875796,9.62941461 8.8,8.59264635 C8.8,7.96710208 8.63494642,7.38800194 8.30432825,6.8558297 Z M1.52333428,1.62119013 L4.63584628,1.62119013 C5.33694076,1.63231737 5.85305258,1.79390421 6.18315975,2.10691824 C6.51939894,2.44170295 6.68751853,2.85050798 6.68751853,3.33333333 C6.68751853,3.81615868 6.51939894,4.21673924 6.18315975,4.53507499 C5.85305258,4.88050314 5.33694076,5.05370102 4.63584628,5.05370102 L1.52333428,5.05370102 L1.52333428,1.62119013 Z M4.81878493,10.2801161 L1.52333428,10.2801161 L1.52333428,6.67537494 L4.81827392,6.67537494 C5.53112144,6.68601838 6.05285429,6.86453798 6.38296146,7.21044993 C6.71306862,7.5616836 6.87863321,7.98403483 6.87863321,8.47798742 C6.87863321,8.96032898 6.71357962,9.37735849 6.38347246,9.72859216 C6.05336529,10.0851476 5.53163245,10.2689889 4.81878493,10.2801161 Z" id="形状"></path></g></g></g></svg>`;
        // 倾斜
        this.$el.querySelector(
          '.ql-italic',
        ).innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>斜体</title><g id="斜体" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0.650076486"><g id="编组-26" fill="#000000"><g id="编组-9" transform="translate(3.258819, 5)"><g id="编组-8"><rect id="矩形" x="2.74118095" y="0" width="6" height="1.5"></rect><rect id="矩形备份-3" x="0.741180955" y="11" width="6" height="1.5"></rect><polygon id="矩形备份-4" transform="translate(4.513107, 6.253512) rotate(-255) translate(-4.513107, -6.253512) " points="-0.630971163 5.42171186 9.19688094 5.39457385 9.65718447 7.11244998 -0.234779143 6.90032061"></polygon></g></g></g></g></svg>`;
        // 下划线
        this.$el.querySelector(
          '.ql-underline',
        ).innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>下划线</title><g id="下划线" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0.65"><g id="编组-27" fill="#000000"><g id="编组-16" transform="translate(7, 5)"><path d="M2.5,0 L2.5,7.348 L2.50453335,7.43776698 C2.56160143,8.09251566 3.15071559,8.61465505 3.88805324,8.66300951 L4,8.66666667 L7,8.66666667 C7.79077135,8.66666667 8.43862384,8.12274814 8.4958857,7.43284156 L8.5,7.33333333 L8.5,0 L10,0 L10,7.66666667 L9.97671914,7.66717023 C9.79193087,8.98236363 8.5296614,10 7,10 L4,10 C2.4703386,10 1.20806913,8.98236363 1.02328086,7.66717023 L1,7.66666667 L1,0 L2.5,0 Z" id="路径" fill-rule="nonzero"></path><polygon id="矩形备份-7" transform="translate(5.5, 12.5) rotate(-270) translate(-5.5, -12.5) " points="4.75 7.5 6.25 7.5 6.25 17.5 4.75 17.5"></polygon></g></g></g></svg>`;
        // 删除线
        this.$el.querySelector(
          '.ql-strike',
        ).innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>删除线</title><g id="取消线" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0.64690778"><g id="编组-28" fill="#000000"><g id="编组-17" transform="translate(6, 5)"><rect id="矩形" x="0" y="5.55516219" width="12" height="1.5"></rect><path d="M2.6129437,0.81222429 C3.97327851,-0.302896911 5.9867324,-0.289076267 8.60363144,0.973356691 L8.88632032,1.11340067 L8.20674557,2.45062846 C5.93020721,1.29369916 4.4399971,1.25408762 3.5638829,1.9722737 C2.93881995,2.48466296 2.58421207,3.4439279 2.53970908,4.48759144 L2.53493367,4.71239334 L1.03493367,4.71239334 C1.03493367,3.17695296 1.53630907,1.69478504 2.6129437,0.81222429 Z" id="路径-7" fill-rule="nonzero"></path><path d="M2.82801003,8.81222429 C4.18834484,7.69710309 6.20179873,7.71092373 8.81869777,8.97335669 L9.10138665,9.11340067 L8.42181189,10.4506285 C6.14527353,9.29369916 4.65506343,9.25408762 3.77894923,9.9722737 C3.15388628,10.484663 2.7992784,11.4439279 2.7547754,12.4875914 L2.75,12.7123933 L1.25,12.7123933 C1.25,11.176953 1.7513754,9.69478504 2.82801003,8.81222429 Z" id="路径-7备份" fill-rule="nonzero" transform="translate(5.175693, 10.356197) scale(-1, -1) translate(-5.175693, -10.356197) "></path></g></g></g></svg>`;
        // 字体颜色<line class="ql-color-label ql-stroke ql-transparent" x1="6" x2="18" y1="21" y2="21" style=""></line>
        this.$el.querySelector(
          '.ql-color .ql-picker-label',
        ).innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>字体颜色</title><g id="a" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0.652371066"><g id="编组-29" fill="#000000" fill-rule="nonzero"><g id="编组" transform="translate(6, 7)"><path d="M4,8 L6,2 L8,8 M5.12432433,0 L0,13 L2.07567567,13 L3.11351351,10.205 L8.88648649,10.205 L9.92432433,13 L12,13 L6.94054054,0 L5.12432433,0 Z" id="形状"></path></g></g></g></svg>`;
        // 背景颜色<line class="ql-fill ql-color-label ql-stroke ql-transparent" x1="2" x2="22" y1="21" y2="21" style=""></line>
        this.$el.querySelector(
          '.ql-background .ql-picker-label',
        ).innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>背景颜色</title><g id="ab" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="编组-30"><g id="编组-10" transform="translate(2, 6)"><rect id="矩形" fill-opacity="0.650322334" fill="#000000" x="0" y="0" width="20" height="16"></rect><circle id="椭圆形" stroke="#FFFFFF" cx="5.5" cy="8.5" r="3" fill-opacity="0.1"></circle><circle id="椭圆形备份-3" stroke="#FFFFFF" cx="14.5" cy="8.5" r="3" fill-opacity="0.1"></circle><rect id="矩形" stroke="#FFFFFF" fill="#979797" x="8.5" y="5.5" width="1" height="6"></rect><rect id="矩形备份-40" stroke="#FFFFFF" stroke-width="2" fill="#D8D8D8" x="12" y="3" width="1" height="8"></rect></g></g></g></svg><div class="tools-border-bg"></div>`;
        // 对齐方式
        this.$el.querySelector(
          '.ql-align .ql-picker-label',
        ).innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>对齐</title><g id="对齐" fill-opacity="0.65" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="编组-18" transform="translate(5, 6)" fill="#000000"><rect id="矩形" x="0" y="0" width="14" height="1.5"></rect><rect id="矩形备份-6" x="0" y="3.5" width="14" height="1.5"></rect><rect id="矩形备份-8" x="0" y="7" width="14" height="1.5"></rect><rect id="矩形备份-9" x="0" y="10.5" width="14" height="1.5"></rect></g></g></svg>`;
        // 首行缩进
        this.$el.querySelectorAll(
          '.ql-indent',
        )[0].innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>首行缩进</title><g id="pc_icon/编辑器/向右" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect id="矩形备份-53" fill="#FFF7F7" opacity="0" x="0" y="0" width="24" height="24"></rect><g id="编组-12" transform="translate(5, 5)" fill="#4A4A52"><rect id="矩形备份-10" x="0" y="0" width="14" height="1.5"></rect><rect id="矩形备份-11" x="0" y="4" width="8" height="1.5"></rect><rect id="矩形备份-14" x="9" y="5.5" width="3" height="1.5"></rect><rect id="矩形备份-12" x="0" y="7" width="8" height="1.5"></rect><rect id="矩形备份-13" x="0" y="11" width="14" height="1.5"></rect><polygon id="三角形" transform="translate(12.5, 6.5) rotate(-270) translate(-12.5, -6.5) " points="12.5 5 15 8 10 8"></polygon></g></g></svg>`;
        // 取消缩进
        this.$el.querySelectorAll(
          '.ql-indent',
        )[1].innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>取消缩进</title><g id="pc_icon/编辑器/向右" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect id="矩形备份-53" fill="#FFF7F7" opacity="0" x="0" y="0" width="24" height="24"></rect><g id="编组-12" transform="translate(5, 5)" fill="#4A4A52"><polygon id="三角形" transform="translate(1.5, 6.5) rotate(270) translate(-12.5, -6.5) " points="12.5 5 15 8 10 8"></polygon><rect id="矩形备份-10" x="0" y="0" width="14" height="1.5"></rect><rect id="矩形备份-11" x="6" y="4" width="8" height="1.5"></rect><rect id="矩形备份-14" x="2" y="5.7" width="3" height="1.5"></rect><rect id="矩形备份-12" x="6" y="7" width="8" height="1.5"></rect><rect id="矩形备份-13" x="0" y="11" width="14" height="1.5"></rect></g></g></svg>`;
        // 列表
        this.$el.querySelector(
          '.ql-list',
        ).innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>列表</title><g id="分点" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0.639914773"><g id="编组-38" fill="#000000"><g id="编组-19" transform="translate(5, 5)"><circle id="椭圆形" cx="0.75" cy="0.75" r="1"></circle><circle id="椭圆形备份" cx="0.75" cy="5.75" r="1"></circle><circle id="椭圆形备份-2" cx="0.75" cy="10.75" r="1"></circle><rect id="矩形备份-31" x="3" y="0" width="10" height="1.5"></rect><rect id="矩形备份-32" x="3" y="5" width="10" height="1.5"></rect><rect id="矩形备份-33" x="3" y="10" width="10" height="1.5"></rect></g></g></g></svg><div class="tools-border"></div>`;
        // 表格
        this.$el.querySelector(
          '.ql-better-table',
        ).innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>表格</title><g id="pc_icon/编辑器/表格" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="编组-40"><rect id="矩形备份-61" fill="#FFF7F7" opacity="0" x="0" y="0" width="24" height="24"></rect><polygon id="矩形" fill-opacity="0.65" fill="#000000" points="6.5 9 17.5 9 17.5 10.5 6.5 10.5"></polygon><polygon id="矩形备份-36" fill-opacity="0.65" fill="#000000" points="6.5 13 17.5 13 17.5 14.5 6.5 14.5"></polygon><polygon id="矩形备份-38" fill-opacity="0.65" fill="#000000" transform="translate(10, 11.750000) rotate(-270) translate(-10, -11.750000) " points="8.75 11 11.25 11 11.25 12.5 8.75 12.5"></polygon><polygon id="矩形备份-40" fill-opacity="0.65" fill="#000000" transform="translate(13.750000, 11.750000) rotate(-270) translate(-13.750000, -11.750000) " points="12.5 11 15 11 15 12.5 12.5 12.5"></polygon><polygon id="矩形备份-39" fill-opacity="0.65" fill="#000000" transform="translate(10, 16) rotate(-270) translate(-10, -16) " points="8.5 15.25 11.5 15.25 11.5 16.75 8.5 16.75"></polygon><polygon id="矩形备份-41" fill-opacity="0.65" fill="#000000" transform="translate(13.750000, 16) rotate(-270) translate(-13.750000, -16) " points="12.25 15.25 15.25 15.25 15.25 16.75 12.25 16.75"></polygon><path d="M19,5 L19,19 L5,19 L5,5 L19,5 Z M17.5,6.5 L6.5,6.5 L6.5,17.5 L17.5,17.5 L17.5,6.5 Z" id="矩形" fill-opacity="0.650841346" fill="#000000" fill-rule="nonzero"></path></g></g></svg>`;
        // 引用
        this.$el.querySelector(
          '.ql-blockquote',
        ).innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>引用</title><g id="符号" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0.65310861"><g id="编组-41" fill="#000000" fill-rule="nonzero"><g id="编组-5" transform="translate(7, 7)"><g id="编组-4" transform="translate(0, 0.003892)"><path d="M4.25,0 L4.27001684,1.87989545 C4.27144885,2.27397787 4.26710105,2.58209993 4.25539048,2.92365837 C4.13159628,6.53432241 3.05593584,8.64285758 0.221514935,8.74602768 L2.66453526e-15,8.75 L2.66453526e-15,7.25 C1.65963718,7.25 2.43294915,6.2178818 2.67839636,4.00174997 L0,4 L0,0 L4.25,0 Z" id="形状结合"></path></g><g id="编组-4备份" transform="translate(6, 0.003892)"><path d="M4.25,0 L4.27001684,1.87989545 C4.27144885,2.27397787 4.26710105,2.58209993 4.25539048,2.92365837 C4.13159628,6.53432241 3.05593584,8.64285758 0.221514935,8.74602768 L2.66453526e-15,8.75 L2.66453526e-15,7.25 C1.65963718,7.25 2.43294915,6.2178818 2.67839636,4.00174997 L0,4 L0,0 L4.25,0 Z" id="形状结合"></path></g></g></g></g></svg>`;
        // 超链接
        this.$el.querySelector(
          '.ql-link',
        ).innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>超链接</title><g id="pc_icon/编辑器/超链接" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g><rect id="矩形备份-64" fill="#FFF7F7" opacity="0" x="0" y="0" width="24" height="24"></rect><g id="编组" transform="translate(5, 4)" fill="#000000" fill-opacity="0.65" fill-rule="nonzero"><path d="M5.04,14 L-2.16271445e-13,8.96 L4.15195959,4.80804041 L4.991,5.648 L1.67944,8.95955959 L5.03944,12.3195596 L8.351,9.008 L9.19195959,9.84804041 L5.04,14 Z M8.96,1.50990331e-13 L14,5.04 L10.3119596,8.72804041 L9.471,7.888 L12.31944,5.03955959 L8.95944,1.67955959 L6.111,4.528 L5.27195959,3.68804041 L8.96,1.50990331e-13 Z" id="形状结合" transform="translate(7, 7) rotate(180) translate(-7, -7) "></path><polygon id="路径-13" transform="translate(6.995534, 6.995534) rotate(180) translate(-6.995534, -6.995534) " points="8.65021442 4.49553391 9.49553391 5.34085339 5.34085339 9.49553391 4.49553391 8.65021442"></polygon></g></g></g></svg>`; // 对齐方式
        // 字号箭头
        /* this.$el.querySelector(
          ".ql-size .ql-picker-label svg"
        ).innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>字号</title><g id="向下" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0.645623907"><g id="编组-35" transform="translate(0, -4)" fill="#000000"><g id="编组-3备份" transform="translate(12.5, 12) rotate(-180) translate(-12.5, -12) translate(6, 5)"><polygon id="三角形备份-2" transform="translate(9.5, 4.5) scale(1, -1) rotate(-180) translate(-4.5, 2.5) " points="6.5 0 9 3 4 3"></polygon></g></g></g></svg>`;
         */ const pickerArr = this.$el.querySelectorAll('.ql-picker-options .ql-picker-item');
        pickerArr[
          pickerArr.length - 1
        ].innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>对齐</title><g id="对齐" fill-opacity="0.65" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="编组-18" transform="translate(5, 6)" fill="#000000"><rect id="矩形" x="0" y="0" width="14" height="1.5"></rect><rect id="矩形备份-6" x="0" y="3.5" width="14" height="1.5"></rect><rect id="矩形备份-8" x="0" y="7" width="14" height="1.5"></rect><rect id="矩形备份-9" x="0" y="10.5" width="14" height="1.5"></rect></g></g></svg><span style="position:absolute;top:105px;color:#444!important">两端对齐</span>`;
        pickerArr[
          pickerArr.length - 2
        ].innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>对齐</title><g id="对齐" fill-opacity="0.65" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="编组-18" transform="translate(5, 6)" fill="#000000"><rect id="矩形" x="7" y="0" width="7" height="1.5"></rect><rect id="矩形备份-6" x="0" y="3.5" width="14" height="1.5"></rect><rect id="矩形备份-8" x="0" y="7" width="14" height="1.5"></rect><rect id="矩形备份-9" x="3.5" y="10.5" width="10.5" height="1.5"></rect></g></g></svg><span style="position:absolute;top:74px;color:#444!important">右对齐</span>`;
        pickerArr[
          pickerArr.length - 3
        ].innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>对齐</title><g id="对齐" fill-opacity="0.65" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="编组-18" transform="translate(5, 6)" fill="#000000"><rect id="矩形" x="3.5" y="0" width="7" height="1.5"></rect><rect id="矩形备份-6" x="0" y="3.5" width="14" height="1.5"></rect><rect id="矩形备份-8" x="0" y="7" width="14" height="1.5"></rect><rect id="矩形备份-9" x="1.5" y="10.5" width="10.5" height="1.5"></rect></g></g></svg><span style="position:absolute;top:42px;color:#444!important">居中对齐</span>`;
        pickerArr[
          pickerArr.length - 4
        ].innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>对齐</title><g id="对齐" fill-opacity="0.65" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="编组-18" transform="translate(5, 6)" fill="#000000"><rect id="矩形" x="0" y="0" width="7" height="1.5"></rect><rect id="矩形备份-6" x="0" y="3.5" width="14" height="1.5"></rect><rect id="矩形备份-8" x="0" y="7" width="14" height="1.5"></rect><rect id="矩形备份-9" x="0" y="10.5" width="10.5" height="1.5"></rect></g></g></svg><span style="position:absolute;top:10px;color:#444!important">左对齐</span>`;

        // let optionsArr = this.$el.querySelectorAll('.ql-picker-options');
        // let childNodeSize = document.createElement('div');
        // childNodeSize.className = 'triangle-size';
        // optionsArr[0].appendChild(childNodeSize);

        // Mark model as touched if editor lost focus
        this.quill.on('selection-change', (range) => {
          if (!range) {
            if (
              this.$refs.editor.children[0].innerHTML === '<p><br></p>' ||
              this.$refs.editor.children[0].innerHTML === '<p></p>' ||
              this.$refs.editor.children[0].innerHTML === ''
            ) {
              const placeHolderWord = document.getElementsByClassName('ql-editor')[0];
              placeHolderWord.dataset.placeholder = '从这里开始输入正文';
            }
            this.$emit('blur', this.quill);
          } else {
            const placeHolderWord = document.getElementsByClassName('ql-editor')[0];
            placeHolderWord.dataset.placeholder = '';
            this.$emit('focus', this.quill);
          }
          const e = document.querySelector('.ql-tooltip,.ql-editing');
          if (e) {
            const { left } = e.style;
            if (left.indexOf('-') === 0) {
              e.style.left = 0;
            }
          }
        });

        // Update model if text changes
        this.quill.on('text-change', (delta, oldDelta, source) => {
          console.log(delta, oldDelta, source);
          let html = this.$refs.editor.children[0].innerHTML;
          const { quill } = this;
          const text = this.quill.getText();
          if (html === '<p><br></p>') html = '';
          this.currentContent = html;
          this.$emit('input', this.currentContent);
          this.$emit('change', { html, text, quill });
        });
        // Emit ready event
        this.$emit('ready', this.quill);
        // 去掉图标焦点
        this.cancelTabindex();

        // this.quill.clipboard.addMatcher(Node.TEXT_NODE, function(node, delta) {
        //   return new Delta().insert(node.data);
        // });
        // this.quill.clipboard.addMatcher('p', function(node, delta) {
        //   return delta.compose(new Delta().retain(delta.length(), { bold: true }));
        // });
      }
    },
  },
};
</script>
<style lang="scss">
.weapp_text_link {
  color: #576b95 !important;
  text-decoration: none !important;
  img {
    width: 100% !important;
    height: 100% !important;
  }
}
.weapp_text_link:before {
  content: '';
  display: inline-block;
  line-height: 1;
  background-size: 12px 12px;
  background-repeat: no-repeat;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAb1BMVEUAAAB4it11h9x2h9x2h9x2htx8j+R8i+B1h9x2h9x3h92Snv91htt2h9x1h9x4h9x1h9x1h9x2idx1h9t2h9t1htt1h9x1h9x1htx2h9x1h912h9x4h913iN17juOOjuN1iNx2h9t4h958i+B1htvejBiPAAAAJHRSTlMALPLcxKcVEOXXUgXtspU498sx69DPu5+Yc2JeRDwbCYuIRiGBtoolAAAA3ElEQVQoz62S1xKDIBBFWYiFYImm2DWF///G7DJEROOb58U79zi4O8iOo8zuCRfV8EdFgbYE49qFQs8ksJInajOA1wWfYvLcGSueU/oUGBtPpti09uNS68KTMcrQ5jce4kmN/HKn9XVPAo702JEdx9hTUrWUqVrI3KwUmM1NhIWMKdwiGvpGMWZOAj1PZuzAxHwhVSplrajoseBnbyDHAwvrtvKKhdqTtFBkL8wO5ijcsS3G1JMNvQ5mdW7fc0x0+ZcnlJlZiflAomdEyFaM7qeK2JahEjy5ZyU7jC/q/Rz/DgqEuAAAAABJRU5ErkJggg==);
  vertical-align: middle;
  font-size: 11px;
  color: #888;
  border-radius: 10px;
  background-color: #f4f4f4;
  margin-right: 6px;
  margin-top: -4px;
  background-position: center;
  height: 20px;
  width: 20px;
}
.weapp_image_link {
  font-size: 0;
  display: inline-block;
  position: relative;
  vertical-align: bottom;
}
.weapp_image_link:after {
  content: ' ';
  width: 26px;
  height: 26px;
  display: block;
  position: absolute;
  top: 9px;
  right: 9px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAAAXNSR0IArs4c6QAABzdJREFUaAXVWV1oXEUUPrubzWa3u2l+bH7WRNuKBlqLrZgiooIPWh+sNsUHLUX6JAjiqyCCRawW+qQP0jdR8M02QYRWQXyoghowolaJ2vpXyTZp2phNd7tNduP5Zu+5zs7euXc3N23NwOzMnHPmnO+7M3d+7kZo9VIkpKvlkP1V97AgGulv2jQCvBEbT/5mME8jD6Gtnyk32+LKBGy2bXYit5a2gLYOXvYikxJ9bXXodPBedV0GeyQvWVVj/LYYbVtTByg2ItNLvQ47aUsfKQWgWYoepehQFz+6DPK6JIZ1Ck1g2kgbpWSYS11KkaE0kwBDqWfYebX1/tJXl7l1BPdLpl7aAhpllLPbHh8f3zw0NPRYIpHYEY1G+53chyCVSiXHeQq5VCpNTE5OfjQ8PHyWVTqJitFGV5OE2YZNYHJBsqUAj3Ed0zTOuZVzG+fk6OjoxkKh8Ea5XD693GRCH/SFD/hyfMI3YiAWYtY8NG4DT1PJjwyCJTgnjxw50pPP5w8xh3yTPLzM2VX+EHzCtxMDsUKTCiKDUUnlcrl9PHXOeyELI4NP+EYMzogVmpROCEMt0wyO27LZbMoZlUoY4AF9K4iBWA2QYhN78iVz8ODBLn6ZjweAWTU1YiEmww0aKSsjIYSRQcb8dUfmepKRp4KYHiMl+ASvJyFRopSphpUGC4BMM4lzXUtMP2BwsACT18rH4tokhISMjE4SLykzuJbvTNADqjgLBVY/2yJRw0bIyOiADJ5EG5bRa7GaBTEw9cDgLOl4n4ANGPHwdezuBgUhkq5Uw8rD/XI6nX6pqg73W+YzwOfjczR5pkBTMyWKRiPU39NK24bStHN7uwvGFmVhYeH1TCbzGutxmihz1k8Y6LasE4FACKlpx7t33549e75neRrKMGnm4iK9+8EUTc9e9XQzmG2jA0/2U2YdnqM1LYyNjW0bGRnJsQUI6cckdFKEhBQEMoSKEB9JXkkmky9CESYtLi3TW+/8RecvXKXuzjg98kA3bRzAzCH6/dwV+uTULM1eWqTbbk3Rs09nKaIjMgIXi8XDqVTqVRbrhEBMJQCXJG5klCJ8wNwtyjDlqa/nFJmujji9cGCQdmxNU+f6FpVRhwy6M38UaOJ03jcUY3qcDVyMjrFgVyPi5SCCUzOflLd4KZuV/fJbQXW5/54OSrbpz7DqCTLokH52bKua+l9gAjbWuCR0K9O7yxxXAN0wTP1ysTojem/Ciuud2jPVd6fiTh5vO0gdbC5W3dIkBJ1ijvuMbhimzktwtbvnM62qfvq1OorZXuzj/knDVucRa7kkXRnBxUwU17IEV7xj3/yQp0RrlLZvCV5QHWw1eBmjempCSJRS8h7RPKFzuRK/2EW1r3R1iGv74/jq23n69ItLNDe/SFFe2h5/eAN1tAf3M7ABM8io0tqbO6lrsx3Of5oLvOS+P5ajv5kQ0pVShXY9iEOyPc3NL9GxE9PKAEv53l09dPsmnGyCkx82KyF260x8/wAX55bUHgMS6XUtdC/v+A/d1+nfibUYief2D1C8JUID/cHvjeHQis1KCGcnfhIZw1Fd89jJaTUiW+9I074nehXAOiOLYNNgdXO1qK1iYLMpZZUTxlLiC82UrZPIi1cqhD0m2Rajp3Y3R0Z8rKQ0sAlmVQoh+BWFqhudPOPiKIPUt6GVVyh3Pamzlb2Fz6KrkhxsNXjFsU5IZMqQb4oTIrCVqWR1M8SBU/eu2+PdwjkNqT1jneF6l8C6hq0urEkIBirjI2CQ557uOPV0t9LlQplOfDZbZ4495vjJGeKbIY9igjZ04RoTPjnYXKy6R0wCmQhSB0nkGH8EHOeFwfc8h73n7ffO0VJ5mTbfkqS778xQZ3ucsJR/OfEPTU2XqIVXsuefGaRsr/3oo4Pyq/N0+zEWiw2zjZy2a64Q+hwAY5BymfPQfsjXB19CA30J2j/SR6Mfz9DZP4sq64DW8zTb+2jPqpCBX2DSMTqxgFklfXQg0Ecp1swFr3R1mca/m1ebK94ZbJY3M9mdd7VTa1zCVIOG+A284InvGiIsxMhht0s6HxXNK/4NaTtff+QzMTCqzwRcCv66+5BMN7apXm+PHj36JqOvnlEgvUEJGICFwwOjXDJ0vHXIhKVaEFiLJ4C3eE1+xgI7IYRSSGGdxdRbkx8aGbdLSpZuGSX1kZ5XmOv2XVteUsRc6adgnZA+Si6ptfixPpDUWvs7xSTkOVJstKb+8GqElNqj1spfkiCEpK965khh9cOSjhua/Gl8+P/wpzGA+iVTL22UkrEiSl19oLyRf+sLwLCk0N8lpdX9/Mour5ew92rrfqC3pkYIobOXncj00qtuCy7AoTfrIjP7+pKBsQAwO9raXvYik9L0q8uh00F51XWZ4PCSia6mNIPVKH0atn6m3GyLSxOg2bbZidxa2gJaOxiKRvqbNjbwuutGbHR7t24GcxUrqIT1tWISOtZ/ATItlVP2kglaAAAAAElFTkSuQmCC)
    no-repeat center;
  background-size: contain;
}
.wxw-img {
  vertical-align: bottom;
}
.my_iframe_link {
}
// .my_iframe_link {
//   .weapp_text_link {
//     text-decoration: none !important;
//     color: #000 !important;
//     &:before {
//       content: '' !important;
//       display: inline-block !important;
//       line-height: 1 !important;
//       background-size: 12px 12px !important;
//       background-repeat: no-repeat !important;
// background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAb1BMVEUAAAB4it11h9x2h9x2h9x2htx8j+R8i+B1h9x2h9x3h92Snv91htt2h9x1h9x4h9x1h9x1h9x2idx1h9t2h9t1htt1h9x1h9x1htx2h9x1h912h9x4h913iN17juOOjuN1iNx2h9t4h958i+B1htvejBiPAAAAJHRSTlMALPLcxKcVEOXXUgXtspU498sx69DPu5+Yc2JeRDwbCYuIRiGBtoolAAAA3ElEQVQoz62S1xKDIBBFWYiFYImm2DWF///G7DJEROOb58U79zi4O8iOo8zuCRfV8EdFgbYE49qFQs8ksJInajOA1wWfYvLcGSueU/oUGBtPpti09uNS68KTMcrQ5jce4kmN/HKn9XVPAo702JEdx9hTUrWUqVrI3KwUmM1NhIWMKdwiGvpGMWZOAj1PZuzAxHwhVSplrajoseBnbyDHAwvrtvKKhdqTtFBkL8wO5ijcsS3G1JMNvQ5mdW7fc0x0+ZcnlJlZiflAomdEyFaM7qeK2JahEjy5ZyU7jC/q/Rz/DgqEuAAAAABJRU5ErkJggg==) !important;
//       vertical-align: middle !important;
//       font-size: 11px !important;
//       color: #888 !important;
//       border-radius: 10px !important;
//       background-color: #f4f4f4 !important;
//       margin-left: 14px !important;
//       margin-bottom: -624px !important;
//       background-position: center !important;
//       height: 20px !important;
//       width: 20px !important;
//     }
//     img {
//       width: 100% !important;
//       height: 100% !important;
//     }
//   }
// }
</style>

<style lang="scss" scoped>
.quill-editor {
  position: relative;
}

.ql-picker.ql-header {
  width: 90px !important;
}

.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  margin-top: -6px !important;
}
.ql-container .qlbt-selection-line.qlbt-selection-line-left::before {
  position: absolute;
  left: -2px;
  top: -2px;
  content: '';
  width: 5px;
  height: 5px;
  background-color: #0589f3;
  border-radius: 5px;
}

.ql-container .qlbt-selection-line.qlbt-selection-line-right::before {
  position: absolute;
  right: -2px;
  bottom: -3px;
  content: '';
  width: 5px;
  height: 5px;
  background-color: #0589f3;
  border-radius: 5px;
}

.quill-better-table-wrapper {
  overflow-x: auto;
}

table.quill-better-table {
  table-layout: fixed;
  border-collapse: collapse;
}
table.quill-better-table td {
  border: 1px solid #000;
  padding: 2px 5px;
}

.qlbt-operation-menu {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  z-index: 100;
  overflow: hidden;
}
.qlbt-operation-menu .qlbt-operation-menu-dividing {
  height: 1px;
  background-color: #efefef;
}
.qlbt-operation-menu .qlbt-operation-menu-subtitle {
  color: #999;
  font-size: 14px;
  padding: 5px 16px;
}
.qlbt-operation-menu .qlbt-operation-color-picker {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 16px 10px;
  background-color: #fff;
  overflow: hidden;
}
.qlbt-operation-menu .qlbt-operation-color-picker .qlbt-operation-color-picker-item {
  width: 20px;
  height: 20px;
  border: 1px solid #595959;
  margin-right: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}
.qlbt-operation-menu .qlbt-operation-menu-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background-color: #fff;
  cursor: pointer;
  color: #595959;
  overflow: hidden;
  text-overflow: ellipsis;
}
.qlbt-operation-menu .qlbt-operation-menu-item:hover {
  background-color: #efefef;
}
.qlbt-operation-menu .qlbt-operation-menu-item .qlbt-operation-menu-icon {
  margin-right: 8px;
  height: 20px;
  width: 20px;
  font-size: 0;
}

.qlbt-col-tool {
  position: absolute;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  z-index: 99;
  height: 16px;
}
.qlbt-col-tool .qlbt-col-tool-cell {
  position: relative;
  background-color: #fff;
  border-top: 1px solid #000;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
}
.qlbt-col-tool .qlbt-col-tool-cell:first-child {
  border-left: 1px solid #000;
}
.qlbt-col-tool .qlbt-col-tool-cell-holder {
  position: absolute;
  right: -1px;
  top: 0;
  bottom: 0;
  z-index: 3;
  width: 1px;
  background-color: transparent;
  cursor: ew-resize;
}
.qlbt-col-tool .qlbt-col-tool-cell-holder:hover {
  background-color: #0589f3;
}
.qlbt-col-tool .qlbt-col-tool-cell-holder::before {
  content: '';
  position: absolute;
  top: 0;
  left: -6px;
  display: block;
  width: 8px;
  height: 100%;
}
.qlbt-col-tool .qlbt-col-tool-cell-holder::after {
  content: '';
  position: absolute;
  top: 0;
  right: -6px;
  display: block;
  width: 8px;
  height: 100%;
}

// 设置字体大小
$list: 11, 70, 1;
@each $value in $list {
  .ql-size-#{value} {
    font-size: $value * 1px;
  }
}
// .ql-size{
//   margin-left:50px;
// }
// 下拉框的样式
.ql-picker-options {
  height: 135px;
  overflow-y: scroll;
  margin-top: 0px !important;
}
/** 设置行高 */

.ql-toolbar {
  text-align: left;
}

.ql-lineHeight {
  margin-left: 45px;
}
.ql-lineHeight::before {
  content: '行高：';
  position: relative;
  top: -2px;
  left: 8px;
}
.ql-lineHeight .ql-picker-label {
  left: 50px;
  top: -25px;
}
.ql-lineHeight .ql-picker-options {
  left: 50px;
}

.ql-lineHeight-0-5 {
  line-height: 0.5;
}

.ql-lineHeight-0-75 {
  line-height: 0.75;
}
.ql-lineHeight-1 {
  line-height: 1;
}

.ql-lineHeight-1-5 {
  line-height: 1.5;
}
.ql-lineHeight-1-75 {
  line-height: 1.75;
}

.ql-lineHeight-2 {
  line-height: 2;
}

.ql-picker.ql-lineHeight .ql-picker-label[data-value='1-5']::before,
.ql-picker.ql-lineHeight .ql-picker-item[data-value='1-5']::before {
  content: '1.5';
}
.ql-picker.ql-lineHeight .ql-picker-label[data-value='1-75']::before,
.ql-picker.ql-lineHeight .ql-picker-item[data-value='1-75']::before {
  content: '1.75';
}
.ql-picker.ql-lineHeight .ql-picker-label[data-value='0-5']::before,
.ql-picker.ql-lineHeight .ql-picker-item[data-value='0-5']::before {
  content: '0.5';
}
.ql-picker.ql-lineHeight .ql-picker-label[data-value='2']::before,
.ql-picker.ql-lineHeight .ql-picker-item[data-value='2']::before {
  content: '2';
}
.ql-picker.ql-lineHeight .ql-picker-label[data-value='1']::before,
.ql-picker.ql-lineHeight .ql-picker-item[data-value='1']::before {
  content: '1';
}
.ql-picker.ql-lineHeight .ql-picker-label[data-value='0-75']::before,
.ql-picker.ql-lineHeight .ql-picker-item[data-value='0-75']::before {
  content: '0.75';
}
</style>
